module.exports = __webpack_public_path__ + "img/jppdimg_mo6.8e2b063e.png";